import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Megaphone, X } from "lucide-react";

export function NoticeBanner() {
  const [notices, setNotices] = useState([]);
  useEffect(() => { api.get("/notices").then(({ data }) => setNotices(data)).catch(() => {}); }, []);
  if (!notices.length) return null;
  const dismiss = async (n) => {
    try { await api.post(`/notices/${n.id}/dismiss`); setNotices((p) => p.filter((x) => x.id !== n.id)); } catch {}
  };
  return (
    <div data-testid="notices-stack" className="space-y-2 mb-4">
      {notices.map((n) => (
        <div key={n.id} data-testid={`notice-${n.id}`} className="flex gap-3 rounded-xl border border-amber-700/60 bg-amber-950/30 p-3 text-amber-100">
          <Megaphone className="h-5 w-5 shrink-0 text-amber-300 mt-0.5" />
          <div className="flex-1 min-w-0">
            <div className="font-display text-sm font-black uppercase tracking-wide">{n.title}</div>
            <p className="text-xs text-amber-100/90 whitespace-pre-wrap mt-0.5">{n.body}</p>
          </div>
          <button type="button" data-testid={`notice-dismiss-${n.id}`} onClick={() => dismiss(n)}
                  className="h-7 px-2 inline-flex items-center gap-1 rounded-md text-[11px] font-bold uppercase bg-amber-900/40 hover:bg-amber-900/70 text-amber-100">
            Entendi <X className="h-3 w-3" />
          </button>
        </div>
      ))}
    </div>
  );
}
